// ============================================================
// frontend/src/theme.js — Charte graphique MKW Solutions
// Couleur primaire extraite du logo : #4f6d89 (bleu MKW)
// ============================================================

const theme = {
  // ─── Couleurs principales ──────────────────────────────────────────────────
  primary:        '#4f6d89',   // Bleu MKW — boutons principaux, navbar active
  primaryLight:   '#6b8fa8',   // Bleu clair — hover, accents
  primaryDark:    '#3a5269',   // Bleu foncé — appui boutons
  primaryBg:      '#eef2f6',   // Bleu très clair — fond cartes, badges

  // ─── Couleur navbar/sidebar ────────────────────────────────────────────────
  navBg:          '#2c3e50',   // Fond sidebar (inchangé — contraste bon avec logo)
  navBgDark:      '#1a252f',   // Fond sidebar bas
  navText:        '#ffffff',
  navActive:      'rgba(79, 109, 137, 0.35)',  // Bleu MKW transparent sur actif

  // ─── Couleurs sémantiques ──────────────────────────────────────────────────
  success:        '#27ae60',
  successBg:      '#e8f5e9',
  successBorder:  '#4caf50',

  danger:         '#e74c3c',
  dangerBg:       '#ffebee',
  dangerBorder:   '#e53935',

  warning:        '#f39c12',
  warningBg:      '#fff3e0',
  warningBorder:  '#ff9800',

  info:           '#2196f3',
  infoBg:         '#e3f2fd',
  infoBorder:     '#2196f3',

  purple:         '#764ba2',
  purpleBg:       '#f3e5f5',

  // ─── Fond et textes ───────────────────────────────────────────────────────
  pageBg:         '#f5f7fb',
  cardBg:         '#ffffff',
  textPrimary:    '#2c3e50',
  textSecondary:  '#666666',
  textMuted:      '#999999',
  border:         '#eeeeee',

  // ─── Statuts devis ────────────────────────────────────────────────────────
  statut: {
    brouillon: { bg: '#fff3e0', color: '#f39c12', label: '⏳ Brouillon' },
    envoye:    { bg: '#e3f2fd', color: '#2196f3', label: '📤 Envoyé' },
    accepte:   { bg: '#e8f5e9', color: '#27ae60', label: '✅ Accepté' },
    refuse:    { bg: '#ffebee', color: '#e74c3c', label: '❌ Refusé' },
    expire:    { bg: '#fff8e1', color: '#f59e0b', label: '⌛ Expiré' },
    facture:   { bg: '#f3e5f5', color: '#764ba2', label: '📑 Facturé' },
  },

  // ─── Statuts paiement ─────────────────────────────────────────────────────
  // Cycle : brouillon → emise → partielle → payee
  //                           ↘ en_retard / annulee
  paiement: {
    brouillon:  { bg: '#fff3e0', color: '#f39c12', label: '⏳ Brouillon' },
    emise:      { bg: '#e3f2fd', color: '#2196f3', label: '📤 Émise' },
    non_payee:  { bg: '#fff3e0', color: '#f39c12', label: '⏳ Non payée' },
    partielle:  { bg: '#e8eaf6', color: '#3f51b5', label: '🔄 Partielle' },
    payee:      { bg: '#e8f5e9', color: '#27ae60', label: '✅ Payée' },
    en_retard:  { bg: '#ffebee', color: '#e74c3c', label: '🔴 En retard' },
    annulee:    { bg: '#f5f5f5', color: '#9e9e9e', label: '❌ Annulée' },
  },

  // ─── Statuts demande ──────────────────────────────────────────────────────
  demande: {
    nouvelle:       { bg: '#e3f2fd', color: '#2196f3', label: '🆕 Nouvelle' },
    en_traitement:  { bg: '#fff3e0', color: '#f39c12', label: '🔧 En traitement' },
    convertie:      { bg: '#e8f5e9', color: '#27ae60', label: '✅ Convertie' },
    rejetee:        { bg: '#ffebee', color: '#e74c3c', label: '❌ Rejetée' },
  },

  // ─── Shadows ──────────────────────────────────────────────────────────────
  shadow:     '0 2px 8px rgba(0,0,0,0.08)',
  shadowMd:   '0 4px 16px rgba(0,0,0,0.12)',
  shadowLg:   '0 8px 32px rgba(0,0,0,0.16)',

  // ─── Border radius ────────────────────────────────────────────────────────
  radius:     '8px',
  radiusMd:   '12px',
  radiusLg:   '16px',
  radiusFull: '50%',

  // ─── Gradients ────────────────────────────────────────────────────────────
  gradientPrimary: 'linear-gradient(135deg, #4f6d89 0%, #3a5269 100%)',
  gradientNav:     'linear-gradient(180deg, #2c3e50 0%, #1a252f 100%)',
  gradientHeader:  'linear-gradient(135deg, #4f6d89 0%, #2c3e50 100%)',

  // ─── Breakpoints ──────────────────────────────────────────────────────────
  bp: {
    sm: '576px',
    md: '768px',
    lg: '992px',
    xl: '1200px',
  },

  // ─── TVA suggestions (champ libre mais suggestions rapides) ───────────────
  tvaSuggestions: [0, 6, 12, 21, 22],
  tvaDefautParticulier: 6,
  tvaDefautProfessionnel: 0,
};

export default theme;
